import { render, staticRenderFns } from "./AddRankModal.vue?vue&type=template&id=2ac34344"
import script from "./AddRankModal.vue?vue&type=script&lang=js"
export * from "./AddRankModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports